export const LIQUIDACIONES_ROUTES = {
    liquidaciones: '/Liquidaciones',
    auditoria: '/Liquidaciones/Auditoria',
    pipelines: '/Liquidaciones/Pipelines',
    pipelineDetalle: (id) => `/Liquidaciones/Pipelines/${id}`,
    comprobantes: '/Liquidaciones/Comprobantes',
    prevision: '/Prevision',
    nueva: '/Liquidaciones/Nueva',
    feeLogistico: '/Liquidaciones/FeeLogistico',
    nuevoFee: '/Liquidaciones/NuevoFee',
    conceptos: '/Conceptos',
    conceptoNuevo: '/Conceptos/Nuevo',
    novedades: '/Novedades',
    novedadNueva: '/Novedades/Nueva',
};
